import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useUserContext } from './UserContext';

const baseUrl = process.env.REACT_APP_API_URL;
const endpointUserDB = `${baseUrl}/users`; 

const UserDBContext = createContext();

export const UserDBProvider = ({ children }) => {
  const { tokens, userInfo } = useUserContext();
  const [userDBData, setUserDBData] = useState(null);
  const [loadingUserDB, setLoadingUserDB] = useState(true);
  const [errorUserDB, setErrorUserDB] = useState(null);

  const fetchUserDBData = async () => {
    try {
      const token = tokens?.accessToken;
      const username = userInfo?.username;

      if (!token || !username) {
        throw new Error("Token ou nom d'utilisateur manquant.");
      }

      const response = await axios.post(
        endpointUserDB,
        { username },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // body stringifié en JSON (toujours le cas en lambda proxy)
    let data = [];
    //console.log("[UserDBContext] Utilisateurs récupérés du backend :", data);

    const body = response?.data?.body;
    if (body) {
      try {
        data = JSON.parse(body);
      } catch (e) {
        console.error("[UserDBContext] Erreur de parsing JSON : ", e, "body reçu : ", body);
        throw new Error("Erreur lors du parsing JSON de la réponse utilisateur.");
      }
    } else if (Array.isArray(response.data)) {
      data = response.data;
    } else {
      console.warn("[UserDBContext] Réponse backend inattendue :", response.data);
      throw new Error("Donnée de réponse utilisateur vide ou mal formatée.");
    }

    //console.log("[UserDBContext] Utilisateur récupéré du backend :", data[0]);
    setUserDBData(data[0] || {});


    } catch (err) {
      console.error('[UserDBContext] Erreur :', err);
      setErrorUserDB(err.message);
    } finally {
      setLoadingUserDB(false);
    }
  };

  useEffect(() => {
    if (tokens?.accessToken && userInfo?.username) {
      fetchUserDBData();
    }
    // eslint-disable-next-line
  }, [tokens, userInfo]);

  return (
    <UserDBContext.Provider
      value={{
        userDBData,
        loadingUserDB,
        errorUserDB,
        refetchUserDB: fetchUserDBData,
      }}
    >
      {children}
    </UserDBContext.Provider>
  );
};

export const useUserDBContext = () => useContext(UserDBContext);
